import { Flex, Separator, Text } from "@radix-ui/themes";

import LeftNav from "@/components/nav/LeftNav";

import GenreFilter from "./GenreFilter";
import BPMFilter from "./BPMFilter";
import KeyFilter from "./KeyFilter";
import MoodsFilter from "./MoodsFilter";
import SoundkitTypesFilter from "./SoundkitTypesFilter";

import NavButton from "@/components/nav/LeftNav/NavButton";
import AllTracksIcon from "@/assets/icons/AllTracksIcon.svg?react";
import BeatIcon from "@/assets/icons/BeatIcon.svg?react";
import SongIcon from "@/assets/icons/SongIcon.svg?react";
import SoundkitIcon from "@/assets/icons/SoundkitIcon.svg?react";

type LegacyFilterSectionProps = {
  searchParameters: any;
  onSetFilter: (param: any) => void;
  onRemoveFilter: (param: string) => void;
};

export default function LegacyFilterSection({
  searchParameters,
  onSetFilter,
  onRemoveFilter,
}: LegacyFilterSectionProps) {
  return (
    <LeftNav>
      <Flex direction="column" className="gap-[4px] pb-[16px]">
        <Text className="text-text-secondary text-[14px] mb-[5px]">
          Marketplace
        </Text>
        <NavButton
          title="Explore"
          icon={<AllTracksIcon width={22} height={22} />}
          isActive={(searchParameters["type"] || "all") === "all"}
          onClick={() => onSetFilter({ type: "all" })}
        />
        <NavButton
          title="Beats"
          icon={<BeatIcon width={22} height={22} />}
          isActive={searchParameters["type"] === "beats"}
          onClick={() => onSetFilter({ type: "beats" })}
        />
        <NavButton
          title="Songs"
          icon={<SongIcon width={22} height={22} />}
          isActive={searchParameters["type"] === "songs"}
          onClick={() => onSetFilter({ type: "songs" })}
        />
        <NavButton
          title="Sound Kits"
          icon={<SoundkitIcon width={22} height={22} />}
          isActive={searchParameters["type"] === "soundkits"}
          onClick={() => onSetFilter({ type: "soundkits" })}
        />
      </Flex>
      <Separator className="w-full mb-[16px] bg-background-quarternary" />
      <Flex direction="column" className="gap-[4px] pb-[16px]">
        <Text className="text-text-secondary text-[14px] mb-[5px]">
          Filters
        </Text>
        <GenreFilter
          parameter={searchParameters["genre"]}
          onSetFilter={onSetFilter}
          onRemoveFilter={onRemoveFilter}
        />

        <MoodsFilter
          parameter={searchParameters["mood"]}
          onSetFilter={onSetFilter}
          onRemoveFilter={onRemoveFilter}
        />

        <KeyFilter
          parameter={searchParameters["key"]}
          onSetFilter={onSetFilter}
          onRemoveFilter={onRemoveFilter}
        />

        <BPMFilter
          parameter={searchParameters["bpm"]}
          onSetFilter={onSetFilter}
          onRemoveFilter={onRemoveFilter}
        />

        {!searchParameters["type"] ||
        searchParameters["type"] === "all" ||
        searchParameters["type"] === "soundkits" ? (
          <SoundkitTypesFilter
            parameter={searchParameters["types"]}
            onSetFilter={onSetFilter}
            onRemoveFilter={onRemoveFilter}
          />
        ) : null}
      </Flex>
      <Separator className="w-full mb-[16px] bg-background-quarternary" />
    </LeftNav>
  );
}
